module.exports = __webpack_public_path__ + "static/media/marketplace-hootsuite-icon.50f8443f.svg";